import classNames from 'classnames';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import {STAGE_RUN_STATUS} from 'workflows/constants/StageRunConstants';

import {AGGREGATED_STAGE_RUN_RADIUS} from './GraphLayoutConstants';
import {HighlightMode} from './StageFlowNodeHighlightUtil';
import {StageRunCircle} from './StageRunVisualization';

interface AggregatedStageRunVisualizationProps {
  numStageRuns: number;
  onClick: (e: React.MouseEvent<SVGGElement>) => void;
  position: {x: number; y: number};
  stageRunStatus: STAGE_RUN_STATUS;
}

export function AggregatedStageRunVisualization(props: AggregatedStageRunVisualizationProps): JSX.Element {
  const {numStageRuns, onClick, position, stageRunStatus} = props;
  return (
    <g>
      <circle
        className={classNames('stageRunLinkVisualization-line', {
          'stageRunLinkVisualization-line--discarded': stageRunStatus === STAGE_RUN_STATUS.DISCARDED,
        })}
        cx={position.x}
        cy={position.y}
        r={AGGREGATED_STAGE_RUN_RADIUS}
      />
      <Tooltip title={`${numStageRuns} ${numStageRuns === 1 ? 'stage run' : 'stage runs'}`} trigger="hover">
        <g className="u-pointer" onClick={onClick}>
          {/** Use background circle to cover up links underneath */}
          <circle
            className="stageRunVisualization-background"
            cx={position.x}
            cy={position.y}
            r={AGGREGATED_STAGE_RUN_RADIUS - 2}
          />
          <StageRunCircle
            highlightMode={HighlightMode.DEFAULT}
            isHovered={false}
            position={position}
            radius={AGGREGATED_STAGE_RUN_RADIUS - 2}
            stageRunStatus={stageRunStatus}
          />
        </g>
      </Tooltip>
    </g>
  );
}
